var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoSystemNotifications = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.002,
    height: 20,
    viewBox: "0 0 20.002 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_system_notifications",
    d: "M130.907,496.221a3.077,3.077,0,0,0,3.01-2.458H127.9A3.078,3.078,0,0,0,130.907,496.221Zm6.079-8.123h-.062A6.543,6.543,0,0,1,131.6,477.74v-.7a.819.819,0,0,0-1.639,0v.881a5.738,5.738,0,0,0-4.916,5.67v2.288a5.5,5.5,0,0,1-1.958,4.206,1.434,1.434,0,0,0,.932,2.523h13.52a1.433,1.433,0,0,0,.924-2.529,5.483,5.483,0,0,1-1.477-1.98Zm.274-11.877a5.326,5.326,0,1,0,5.326,5.326A5.326,5.326,0,0,0,137.26,476.221Zm.819,7.169a.614.614,0,1,1-1.229,0h0v-2.663h-.41a.615.615,0,1,1,0-1.229h1.027a.615.615,0,0,1,.614.614Z",
    transform: "translate(-122.584 -476.221)",
    fill: "#8d939c"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoSystemNotifications);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_system_notifications.4a9aac6be845e091be74a136da80c592.svg";